export type ProductMeasure = {
    id: number
    name: string
    kind: ProductMeasureKind
    isActive?: boolean
}

export type ProductInventoryCategory = {
    id: number
    name: string
    isActive?: boolean
}

export type ProductInventoryCategoryDetails = {
    id: number
    name: string
    modifiedDate: string
    modifiedByUserEmail: string
}

export type ProductInventory = {
    id: number
    name: string
    unitPrice: number
    quantity: number
    description: string
    productMeasure: ProductMeasure
    productInventoryCategory: ProductInventoryCategory
    tenantId: number
}

export type WorkReportProduct = {
    id: number
    workReportId?: number
    productInventory: ProductInventory
    productQuantity: number
    productPrice: number
}

/**
 * Scopes a product measure so each dropdown only offers the measures that make sense for it.
 */
export enum ProductMeasureKind {
    Inventory = 1,
    Labor = 2,
    Service = 3,
    Yield = 4
}
